var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 225,
    viewBox: "0 0 388 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388 219.367C388 219.367 376.062 224.59 358.154 224.59C340.246 224.59 47.7538 224.59 29.8462 224.59C11.9385 224.59 0 219.367 0 219.367L194 217.875L388 219.367Z",
    fill: "url(#paint0_linear_2416_1160)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.439 211.908H36.5625V7.46154C36.5625 3.34053 39.903 0 44.024 0H343.978C348.099 0 351.439 3.34053 351.439 7.46154V211.908Z",
    fill: "url(#paint1_linear_2416_1160)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6797 211.906V7.4595C37.6797 3.96227 40.5248 1.11719 44.022 1.11719H343.976C347.473 1.11719 350.318 3.96227 350.318 7.4595V211.906H37.6797Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388 211.906H0V219.368H388V211.906Z",
    fill: "url(#paint2_linear_2416_1160)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.114 217.129H167.883C164.999 217.129 162.66 214.791 162.66 211.906H225.337C225.337 214.791 222.999 217.129 220.114 217.129Z",
    fill: "url(#paint3_linear_2416_1160)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.318 205.195H37.6797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.601 2.23438L38.8008 158.181V7.45745C38.8008 4.5773 41.1437 2.23438 44.0239 2.23438H174.601Z",
    fill: "url(#paint4_linear_2416_1160)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M342.485 14.9219H45.5156V199.968H342.485V14.9219Z",
    fill: "#421563"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194 10.4457C195.236 10.4457 196.239 9.44348 196.239 8.20721C196.239 6.97094 195.236 5.96875 194 5.96875C192.764 5.96875 191.762 6.97094 191.762 8.20721C191.762 9.44348 192.764 10.4457 194 10.4457Z",
    fill: "#232323"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2416_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.993 96.6562L274.93 43.8169C274.121 33.3003 265.902 25.0812 255.386 24.2726L202.546 20.2094C196.175 19.7201 190.421 21.849 185.903 26.3668L110.441 101.829C106.585 105.685 104.461 110.828 104.461 116.31C104.461 121.792 106.585 126.935 110.441 130.791L168.412 188.761C172.404 192.754 177.647 194.75 182.892 194.75C188.136 194.75 193.381 192.754 197.373 188.761L272.836 113.299C277.354 108.781 279.483 103.026 278.993 96.6562ZM265.12 105.583L189.657 181.045C185.927 184.775 179.858 184.775 176.128 181.045L118.157 123.075C116.362 121.279 115.373 118.877 115.373 116.31C115.373 113.743 116.362 111.34 118.157 109.545L193.62 34.0829C195.653 32.0495 198.001 31.0534 200.772 31.0534C201.085 31.0535 201.398 31.0656 201.71 31.0899L254.549 35.1531C259.661 35.5456 263.657 39.5412 264.049 44.6531L268.113 97.4928C268.357 100.678 267.378 103.324 265.12 105.583ZM232.254 46.2163C220.823 46.2163 211.523 55.5165 211.523 66.948C211.523 78.3795 220.823 87.6797 232.254 87.68C243.686 87.6797 252.986 78.3795 252.986 66.948C252.986 55.5165 243.686 46.2163 232.254 46.2163ZM232.254 76.7675C226.84 76.7672 222.435 72.3623 222.435 66.948C222.435 61.5337 226.84 57.1288 232.254 57.1288C237.669 57.1288 242.074 61.5337 242.074 66.948C242.074 72.3623 237.669 76.7672 232.254 76.7675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89 100.72L165.295 116.241L161.035 120.501L151.683 114.579L157.57 123.966L153.309 128.226L137.824 118.786L141.571 115.038L151.542 122.11L144.983 111.627L148.784 107.826L159.143 114.367L152.143 104.467L155.89 100.72ZM166.341 95.1834C167.472 94.0521 168.751 93.5394 170.177 93.6455C171.603 93.728 172.964 94.4174 174.261 95.7138L180.041 101.494L176.576 104.959L171.255 99.6382C170.69 99.0725 170.1 98.7779 169.488 98.7543C168.863 98.719 168.303 98.9488 167.808 99.4437C167.29 99.9623 167.048 100.534 167.083 101.158C167.107 101.771 167.402 102.361 167.967 102.926L173.288 108.247L169.823 111.712L156.742 98.6306L160.207 95.1657L164.785 99.7443C164.644 98.99 164.697 98.2181 164.944 97.4285C165.192 96.6153 165.657 95.867 166.341 95.1834ZM172.856 87.0067C172.243 87.6195 171.583 87.9495 170.876 87.9966C170.169 88.0202 169.562 87.7786 169.055 87.2718C168.537 86.7533 168.289 86.1405 168.313 85.4334C168.348 84.7145 168.672 84.0486 169.285 83.4358C169.886 82.8347 170.54 82.5224 171.247 82.4989C171.966 82.4635 172.585 82.7051 173.103 83.2237C173.61 83.7304 173.846 84.3432 173.811 85.0621C173.775 85.7575 173.457 86.4056 172.856 87.0067ZM175.49 86.2112L185.407 96.1284L181.942 99.5932L172.025 89.676L175.49 86.2112ZM190.279 85.3517L193.232 88.3039L191.729 89.8065C189.195 92.3403 186.673 92.3521 184.163 89.8419L180.893 86.5715L179.673 87.7913L176.791 84.9098L178.011 83.69L175.607 81.2859L179.089 77.8034L181.494 80.2075L183.297 78.4044L186.178 81.2859L184.375 83.089L187.698 86.4124C187.97 86.6835 188.223 86.819 188.459 86.819C188.706 86.8072 188.977 86.654 189.272 86.3594L190.279 85.3517ZM199.223 72.166C199.494 72.4371 199.747 72.7258 199.983 73.0322L193.424 79.5906C194.002 80.0974 194.556 80.3566 195.086 80.3684C195.616 80.3566 196.088 80.1445 196.5 79.732C197.078 79.1546 197.231 78.4828 196.96 77.7168L200.654 74.0222C201.185 74.8589 201.497 75.7722 201.591 76.7622C201.686 77.7286 201.55 78.7008 201.185 79.679C200.819 80.6572 200.23 81.5528 199.417 82.366C198.439 83.3442 197.36 84.01 196.182 84.3636C195.015 84.7054 193.831 84.7112 192.629 84.3813C191.438 84.0395 190.325 83.3501 189.288 82.313C188.251 81.2759 187.567 80.1681 187.237 78.9896C186.895 77.7993 186.895 76.6208 187.237 75.454C187.591 74.2755 188.262 73.1913 189.252 72.2014C190.23 71.2232 191.297 70.5573 192.452 70.2038C193.607 69.8502 194.774 69.8384 195.952 70.1684C197.119 70.4866 198.209 71.1525 199.223 72.166ZM194.821 74.8353C194.397 74.4111 193.925 74.2225 193.407 74.2696C192.876 74.305 192.399 74.5348 191.975 74.9591C191.55 75.3833 191.321 75.8488 191.285 76.3556C191.238 76.8506 191.397 77.3632 191.763 77.8936L194.821 74.8353ZM181.417 148.555L185.289 144.684L187.94 147.335L180.604 154.672L168.141 142.209L171.606 138.744L181.417 148.555ZM183.754 141.586C182.729 140.561 182.016 139.483 181.615 138.351C181.227 137.208 181.144 136.112 181.368 135.063C181.604 134.003 182.116 133.077 182.906 132.288C183.589 131.604 184.314 131.151 185.08 130.927C185.846 130.703 186.595 130.685 187.325 130.874L185.946 129.495L189.411 126.03L199.328 135.947L195.864 139.412L194.485 138.033C194.673 138.764 194.65 139.518 194.414 140.296C194.19 141.062 193.742 141.781 193.071 142.453C192.281 143.242 191.356 143.755 190.295 143.99C189.246 144.214 188.15 144.132 187.007 143.743C185.864 143.331 184.78 142.612 183.754 141.586ZM190.896 134.445C190.26 133.808 189.582 133.484 188.863 133.472C188.156 133.449 187.549 133.69 187.042 134.197C186.524 134.716 186.276 135.328 186.3 136.036C186.312 136.731 186.642 137.403 187.29 138.051C187.926 138.687 188.604 139.023 189.323 139.058C190.03 139.082 190.643 138.835 191.161 138.316C191.668 137.809 191.91 137.202 191.886 136.495C191.874 135.776 191.544 135.093 190.896 134.445ZM196.229 121.97C196.029 121.227 196.047 120.479 196.282 119.725C196.506 118.959 196.954 118.24 197.626 117.568C198.415 116.778 199.335 116.272 200.384 116.048C201.444 115.812 202.54 115.894 203.672 116.295C204.815 116.684 205.899 117.391 206.924 118.416C207.95 119.442 208.663 120.532 209.063 121.687C209.464 122.818 209.547 123.914 209.311 124.975C209.087 126.024 208.58 126.943 207.791 127.733C207.119 128.404 206.406 128.858 205.652 129.094C204.885 129.318 204.131 129.329 203.389 129.129L204.768 130.508L201.303 133.973L188.221 120.891L191.686 117.426L196.229 121.97ZM203.406 121.934C202.758 121.286 202.081 120.962 201.374 120.962C200.666 120.938 200.059 121.18 199.553 121.687C199.046 122.194 198.798 122.806 198.81 123.525C198.834 124.232 199.164 124.904 199.8 125.541C200.448 126.189 201.126 126.525 201.833 126.548C202.552 126.56 203.165 126.312 203.672 125.806C204.178 125.299 204.42 124.692 204.396 123.985C204.373 123.254 204.043 122.571 203.406 121.934ZM217.72 107.409C217.991 107.68 218.244 107.969 218.48 108.275L211.922 114.833C212.499 115.34 213.053 115.599 213.583 115.611C214.114 115.599 214.585 115.387 214.997 114.975C215.575 114.397 215.728 113.726 215.457 112.96L219.152 109.265C219.682 110.102 219.994 111.015 220.089 112.005C220.183 112.971 220.047 113.944 219.682 114.922C219.317 115.9 218.727 116.796 217.914 117.609C216.936 118.587 215.858 119.253 214.679 119.606C213.513 119.948 212.328 119.954 211.126 119.624C209.936 119.282 208.822 118.593 207.785 117.556C206.748 116.519 206.064 115.411 205.734 114.232C205.393 113.042 205.393 111.864 205.734 110.697C206.088 109.518 206.76 108.434 207.75 107.444C208.728 106.466 209.794 105.8 210.949 105.447C212.104 105.093 213.271 105.081 214.449 105.411C215.616 105.729 216.706 106.395 217.72 107.409ZM213.318 110.078C212.894 109.654 212.422 109.465 211.904 109.512C211.374 109.548 210.896 109.778 210.472 110.202C210.048 110.626 209.818 111.092 209.783 111.598C209.735 112.093 209.895 112.606 210.26 113.136L213.318 110.078ZM214.595 94.518L227.676 107.6L224.211 111.064L211.13 97.9828L214.595 94.518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2416_1160",
    x1: 194,
    y1: 219.377,
    x2: 194,
    y2: 224.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3564,
    stopColor: "#808185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5045,
    stopColor: "#78797D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7A7B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2416_1160",
    x1: 194.001,
    y1: 0,
    x2: 194.001,
    y2: 216.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000159439,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0092,
    stopColor: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0982,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1199,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1519,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2384,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5727,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5998,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6294,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9015,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9334,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9577,
    stopColor: "#474747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2416_1160",
    x1: 0,
    y1: 215.637,
    x2: 388,
    y2: 215.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49484D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0121,
    stopColor: "#D3D4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0282,
    stopColor: "#D0D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0804,
    stopColor: "#8C8D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0918,
    stopColor: "#85868B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5113,
    stopColor: "#CBCCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9264,
    stopColor: "#85868B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#8B8C91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#D0D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#D3D4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2416_1160",
    x1: 162.66,
    y1: 214.518,
    x2: 225.337,
    y2: 214.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    stopColor: "#84848A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3011,
    stopColor: "#8F8F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#ADADB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7161,
    stopColor: "#8A8B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9495,
    stopColor: "#7B7C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2416_1160",
    x1: 32.525,
    y1: 6.0317,
    x2: 100.476,
    y2: 73.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000478316,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2416_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.6,
    height: 174.6,
    fill: "white",
    transform: "translate(104.461 20.1406)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.45a9d22d6f27cd0f78a1de68f10776d1.svg";
export { ForwardRef as ReactComponent };